import styled from 'styled-components';
import { colors } from '../colors';

interface cardHeaderProps {
	projectHeading?: boolean;
	overFlow?: boolean;
	projectHeadingSub?: boolean;
}

const CardHeader = styled.div<cardHeaderProps>`
	background: ${colors.GreyF6};
	padding: 12px 15px;
	cursor: pointer;
	font-weight: 600;
	font-size: 16px;
	line-height: 19px;
	color: #000000;
	display: flex;
	align-items: center;
	position: relative;
	justify-content: space-between;
	a {
		color: ${colors.Black} !important;
	}
	.icon-delete {
		color: ${colors.Grey58} !important;
		cursor: pointer;
		padding: 5px;
		position: absolute;
		right: 10px;
		border-radius: 3px;
		padding: 5px;
	}
	${({ projectHeading }) =>
		projectHeading &&
		`background:transparent;
		padding:24px;
		border-bottom: 1px solid ${colors.GreyE1};
		h1{
			font-size: 18px;
			line-height: 21px;
			color: ${colors.Grey58} !important;
			span{
				color: ${colors.Grey58} !important;
				font-family: 'RubikMedium';
				&:hover, &:focus, &:active {
					color: ${colors.Grey58} !important;
				}
			}
		}

	`};
	${({ projectHeadingSub }) =>
		projectHeadingSub &&
		`background: ${colors.White};
		padding:12px 24px;
		border: 1px solid ${colors.GreyE1};
		border-bottom: 0px solid ${colors.GreyE1};
		h1{
			font-size: 18px;
			line-height: 21px;
			color: ${colors.Grey58} !important;
			span{
				color: ${colors.Grey58} !important;
				font-family: 'RubikMedium';
				&:hover, &:focus, &:active {
					color: ${colors.Grey58} !important;
				}
			}
		}

	`};
	${({ overFlow }) =>
		overFlow &&
		`a{ display: inline-block;
            width: 200px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
		},
	
    `};
`;
export default CardHeader;
